import { constants } from '../../constants/app-contants';

export const FooterMenuItems = [
  {
    menu: 'About us',
    href: 'about-us',
    submenus: [
      {
        name: 'Who We Are',
        link: '/about-us',
        fragment: 'who-we-are',
      },
      {
        name: 'Our Story',
        link: 'about-us',
        fragment: 'our-story',
      },
      {
        name: 'Our Approach',
        link: 'about-us',
        fragment: 'our-approach',
      },
      {
        name: 'Values',
        link: 'about-us',
        fragment: 'values',
      },
    ],
  },
  {
    menu: 'Join LM Tribe',
    submenus: [
      {
        name: 'LM Forum',
        link: constants.TRIBE_URL,
      },
      {
        name: 'LM Recommends',
        link: '/home/recommends',
      },
      {
        name: 'Volunteer',
        link: '/join-lm-tribe',
        fragment: 'volunteer',
      },
      {
        name: 'Partner With Us',
        link: '/join-lm-tribe/partner',
      },
    ],
  },
  {
    menu: 'Events',
    submenus: [
      {
        name: 'Featured Event',
        link: '/events',
      },
      {
        name: 'Past Event',
        link: '/events/list',
      },
      {
        name: 'Financial Report',
        link: 'donate',
        fragment: 'financial-report',
      },
    ],
  },
  {
    menu: 'Support',
    submenus: [
      {
        name: 'FAQ',
        link: '/faq',
      },
      {
        name: 'Contact',
        link: '/contact-us',
      },
      {
        name: 'Donate',
        link: '/donate',
      },
      {
        name: 'Shop',
        link: '/shop',
      },
    ],
  },
];
